/**
 * Cryptographic nonce utilities for social sign-in replay protection.
 * Shared by Google and Apple sign-in flows.
 *
 * Google: raw nonce passed to GSI → raw nonce embedded in JWT → backend direct-compares
 * Apple: raw nonce → SHA-256 hash passed to Apple SDK → hash in JWT → backend hashes raw and compares
 */

/** Generate a cryptographically random nonce (hex string, 64 chars / 32 bytes) */
export function generateNonce(length = 32): string {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, '0')).join('');
}

/** SHA-256 hash using Web Crypto API (Apple requires hashed nonce in SDK init) */
export async function sha256(plain: string): Promise<string> {
  const data = new TextEncoder().encode(plain);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hash), (b) => b.toString(16).padStart(2, '0')).join('');
}
